/*
 * Copyright (c) 2021. Sanish Manandhar
 * All Rights Reserved
 */

// Import actionType constants
import {
  TAX_RETURN_FETCH_REQUEST,
  TAX_RETURN_FETCH_REQUEST_SUCCESS,
  TAX_RETURN_FETCH_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const taxReturnReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TAX_RETURN_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TAX_RETURN_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TAX_RETURN_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default taxReturnReducer;
